import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';
import { YamatoBaggageGuidanceSubHeaderComponent } from './yamato-baggage-guidance-sub-header.component';

@NgModule({
  declarations: [YamatoBaggageGuidanceSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [YamatoBaggageGuidanceSubHeaderComponent],
})
export class YamatoBaggageGuidanceSubHeaderModule {}
